import { render, staticRenderFns } from "./placeholderAnalyticKpis.vue?vue&type=template&id=08050af2"
import script from "./placeholderAnalyticKpis.vue?vue&type=script&lang=js"
export * from "./placeholderAnalyticKpis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports